import { pxToRem } from 'utils/helpers'

export const HANDLE_SIZE = pxToRem(80)

export const RAIL_HEIGHT = '8px'
